import { db } from "../plugins/firebase.js";

const artistDoc = async artistName => {
  const docRef = db.collection("artists").doc(artistName);
  return await docRef.get().then(snapshot => {
    return snapshot;
  });
}

export const getArtistsNames = async () => {
  const collection = db.collection("artists").orderBy('sortIndex', 'asc');
  const snap = await collection.get().then(snapshot => {
    return snapshot;
  });
  let names = []
  snap.forEach(doc => {
    names.push(doc.id.toString());
  });
  return names;
}

export const getArtistProfile = async artistName => {
  let artist = {};
  artist.name = artistName;
  const snap = await artistDoc(artistName);
  artist.description = snap.get("description");
  artist.image = snap.get("image");
  artist.url_twitter = snap.get("url_twitter");
  artist.url_instagram = snap.get("url_instagram");
  artist.url_facebook = snap.get("url_facebook");
  return artist;
}

export const getMusicInfo = async artistName => {
  const snap = await artistDoc(artistName);
  let music = {};
  music = snap.get("music");
  return music;
}

export const getLiveInfo = async artistName => {
  const snap = await artistDoc(artistName);
  let live = {};
  live = snap.get("live");
  return live;
}
